import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {ICurbsideLocation, ILocation} from '../../store';
import {IBaseResponse, WebService} from '../../services';

type TResponse = IBaseResponse<{
	curbsideLocations: ICurbsideLocation[];
}>;

@Module({name: 'curbsideLocations', namespaced: true})
class CurbsideLocationsModule extends VuexModule {
	curbsideLocations: ICurbsideLocation[] = [];

	get curbsideLocation() {
		return (id: string) => {
			return this.curbsideLocations.find((curbLoc: ICurbsideLocation) => {
				return curbLoc.id === id;
			}) ?? null;
		};
	}

	@Action
	async fetchLocations(locationId: ILocation['id']) {
		await WebService.loggedInStarted;
		const response = await WebService.authenticatedClient.get<TResponse>(
			`locations/${locationId}/curbside_locations`
		);
		this.setLocations(response.data.data.curbsideLocations);
	}

	@Mutation
	public setLocations(curbsideLocations: ICurbsideLocation[]) {
		this.curbsideLocations = curbsideLocations ?? [];

		// sort by highest priority value first
		this.curbsideLocations.sort(
			(locA: ICurbsideLocation, locB: ICurbsideLocation) => {
				if(locA.priority < locB.priority) {
					return 1;
				}
				if(locA.priority > locB.priority) {
					return -1;
				}
				return 0;
			}
		);
	}
}

export {
	CurbsideLocationsModule
};
